import { render } from "./SalesManagersList.vue?vue&type=template&id=0e79c066"
import script from "./SalesManagersList.vue?vue&type=script&lang=js"
export * from "./SalesManagersList.vue?vue&type=script&lang=js"
script.render = render

export default script